export enum MeetingAttendeesType {
  VOTER = 'VOTER',
  OBSERVER = 'OBSERVER',
}
